export default __webpack_public_path__ + "static/media/insta.2aaf0bef.png";